var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaskGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 295,
    viewBox: "0 0 371 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3633_16811",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 341,
    height: 278
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.1927,
    width: 340,
    height: 278,
    rx: 39.0361,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3633_16811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-263.807 309V132.073C-230.049 111.901 -141.894 79.1208 -59.3448 109.379C43.8418 147.202 79.5909 193.778 170.675 192.73C267.318 191.617 276.558 57.1344 413.804 93.1161L422.193 309H-263.807Z",
    fill: "url(#paint0_linear_3633_16811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-263.807 309V132.073C-230.049 111.901 -141.894 79.1208 -59.3448 109.379C43.8418 147.202 79.5909 193.778 170.675 192.73C267.318 191.617 276.558 57.1344 413.804 93.1161L422.193 309H-263.807Z",
    stroke: "#4B69B2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-263.807 309V132.073C-230.049 111.901 -141.894 79.1208 -59.3448 109.379C43.8418 147.202 79.5909 193.778 170.675 192.73C267.318 191.617 276.558 57.1344 413.804 93.1161L422.193 309H-263.807Z",
    stroke: "#4B69B2",
    strokeOpacity: 0.2,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-367.807 288V111.257C-334.552 91.1054 -247.712 58.3595 -166.393 88.5864C-64.7449 126.37 -29.5288 172.898 60.1977 171.85C155.399 170.739 281.992 -8.17325 417.193 27.771V280.008L-367.807 288Z",
    fill: "url(#paint1_linear_3633_16811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-367.807 288V111.257C-334.552 91.1054 -247.712 58.3595 -166.393 88.5864C-64.7449 126.37 -29.5288 172.898 60.1977 171.85C155.399 170.739 281.992 -8.17325 417.193 27.771V280.008L-367.807 288Z",
    stroke: "#4B69B2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-367.807 288V111.257C-334.552 91.1054 -247.712 58.3595 -166.393 88.5864C-64.7449 126.37 -29.5288 172.898 60.1977 171.85C155.399 170.739 281.992 -8.17325 417.193 27.771V280.008L-367.807 288Z",
    stroke: "#4B69B2",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3633_16811",
    x1: 151.567,
    y1: 173.117,
    x2: 154.028,
    y2: 307.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#6182D5",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#395497",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3633_16811",
    x1: 41.374,
    y1: 152.258,
    x2: 43.8667,
    y2: 286.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#6182D5",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#395497",
    stopOpacity: 0.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup);
export default __webpack_public_path__ + "static/media/Mask_Group.59609e8c644c6e839241b00b23b0a7c5.svg";
export { ForwardRef as ReactComponent };